var map = {
	"./Accordion.svg": 542,
	"./Breadcrumb.svg": 543,
	"./Button.svg": 544,
	"./Checkbox.svg": 545,
	"./Code snippet.svg": 546,
	"./Content switcher.svg": 547,
	"./Data table.svg": 548,
	"./Date picker.svg": 549,
	"./Dropdown.svg": 550,
	"./File uploader.svg": 551,
	"./Form.svg": 552,
	"./Inline loading.svg": 553,
	"./Link.svg": 554,
	"./List.svg": 555,
	"./Loading.svg": 556,
	"./Modal.svg": 557,
	"./Multiselect.svg": 558,
	"./NoImage.svg": 329,
	"./Notification.svg": 559,
	"./Number input.svg": 560,
	"./Overflow menu.svg": 561,
	"./Pagination.svg": 562,
	"./Progress indicator.svg": 563,
	"./Radio button.svg": 564,
	"./Search.svg": 565,
	"./Select.svg": 566,
	"./Slider.svg": 567,
	"./Structured list.svg": 568,
	"./Tabs.svg": 569,
	"./Tag.svg": 570,
	"./Text input.svg": 571,
	"./Tile.svg": 572,
	"./Toggle.svg": 573,
	"./Tooltip.svg": 574,
	"./UI shell.svg": 575
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 541;